import type * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

type AvatarContainerType = { preview?: boolean };

const Container = styled.div<Pick<AvatarContainerType, 'preview'>>`
  ${tw`row-start-1 row-end-2 place-content-center`}
  ${({ preview }) => (preview ? tw`grid` : tw`sm:grid`)}

  & > *:is(img, svg) {
    ${tw`object-contain`}
    ${({ preview }) => preview && tw`w-8 h-8`}
  }
`;

export const AvatarContainer: React.FunctionComponent<AvatarContainerType> = ({
  children,
  preview = false,
}) => {
  return <Container preview={preview}>{children}</Container>;
};
